// AsideBar.js
import React, { useMemo } from 'react';
import { Accordion, Nav } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { URL } from '../config/url';
import './AsideBarStyle.css';

import { FaUsers, FaRegCalendar, FaBirthdayCake } from "react-icons/fa";
import { IoNewspaperOutline } from "react-icons/io5";
import { RiContractLine } from "react-icons/ri";
import { GoGear } from "react-icons/go";

import logo from '../assets/logo-branco.png'

import { useAuth } from '../context/auth';
import { MdOutlineDashboard } from "react-icons/md";
import { getDashboardTabs } from '../utilities/dashboard';
import { brandShade } from '../utilities/brandColors';
import { BRAND_FALLBACK, useTheme } from '../context/theme';

const AsideBar = ({ children, open, setOpen }) => {
  const navigate = useNavigate();
  const { user } = useAuth()
  const { brandColor } = useTheme()

  // Fundo do submenu aberto: a cor do menu (Configurações > Menu) mais escura
  const submenuColor = useMemo(() => brandShade(brandColor, BRAND_FALLBACK), [brandColor])

  function closeMenu() {
    setOpen(false)
  }

  function navigateRoute(route) {
    closeMenu()
    navigate(route)
  }

  return (
    // <div className='d-flex div-geral' >
    <div className='d-flex '>
      <Nav
        className={`flex-column justify-content-between ${open ? 'asideBarOpen' : 'asideBar'}`}
        // style={{ backgroundColor: '#2d3635', color: 'white' }}
        style={{
          backgroundColor: brandColor,
          color: 'white'
        }}
      >
        <div >

          <Accordion data-bs-theme="dark" className='d-flex flex-column gap-2' style={{ backgroundColor: brandColor }}>

            {/* <p onClick={() => { navigate(URL.home); closeMenu() }} className='m-0 p-0 ps-2' style={{ cursor: 'pointer' }}>
              <span className='me-2 pb-1'><FaHome /></span>
              <span className='sidebar_title '>Home</span>
            </p> */}
            {/* Só para quem tem ao menos uma aba do Dashboard (usuário carregado ao abrir o sistema: muda com F5) */}
            {getDashboardTabs(user).length ?
              <p onClick={() => { navigate(URL.dashboard); closeMenu() }} className='m-0 p-0 ps-2' style={{ cursor: 'pointer' }}>
                <span className='me-2 pb-1'><MdOutlineDashboard /></span>
                <span className='sidebar_title '>Dashboard</span>
              </p> : ''}
            <p onClick={() => { navigate(URL.calendario); closeMenu() }} className='m-0 p-0 ps-2' style={{ cursor: 'pointer' }}>
              <span className='me-2 pb-1'><FaRegCalendar /></span>
              <span className='sidebar_title '>Agenda</span>
            </p>
            <p onClick={() => { navigate(URL.pacientes_lista); closeMenu() }} className='m-0 p-0 ps-2' style={{ cursor: 'pointer' }}>
              <span className='me-2 pb-1'><FaUsers /></span>
              <span className='sidebar_title '>Pacientes</span>
            </p>
            <p onClick={() => { navigate(URL.birthdays); closeMenu() }} className='m-0 p-0 ps-2' style={{ cursor: 'pointer' }}>
              <span className='me-2 pb-1'><FaBirthdayCake /></span>
              <span className='sidebar_title '>Aniversariantes</span>
            </p>
            <p onClick={() => { navigate(URL.prontuario_lista); closeMenu() }} className='m-0 p-0 ps-2' style={{ cursor: 'pointer' }}>
              <span className='me-2 pb-1'><IoNewspaperOutline /></span>
              <span className='sidebar_title '>Prontuários</span>
            </p>
            <p onClick={() => { navigate(URL.contrato_lista); closeMenu() }} className='m-0 p-0 ps-2' style={{ cursor: 'pointer' }}>
              <span className='me-2 pb-1'><RiContractLine /></span>
              <span className='sidebar_title '>Contratos</span>
            </p>
            <p onClick={() => { navigate(URL.financeiro_lista); closeMenu() }} className='m-0 p-0 ps-2' style={{ cursor: 'pointer' }}>
              <span className='me-2 pb-1'><RiContractLine /></span>
              <span className='sidebar_title '>Financeiros</span>
            </p>

            <Accordion.Item eventKey="1" className='m-0 p-0' style={{ backgroundColor: submenuColor }}>
              <Accordion.Header
                className='m-0 p-0 ps-2'
                style={{ backgroundColor: submenuColor }}
              >
                <span className='me-2 pb-1'><GoGear /></span>
                <span className='sidebar_title pb-1'>Configurações</span>
              </Accordion.Header>
              <Accordion.Body className='p-0 ps-4 d-flex flex-column gap-1' style={{ backgroundColor: submenuColor }}>
                <p onClick={() => navigateRoute(URL.status_lista)} className='m-0 sidebar_subtitle pt-2 pb-2' style={{ cursor: 'pointer' }}>Status</p>
                <p onClick={() => navigateRoute(URL.perguntas_lista)} className='m-0 sidebar_subtitle  pb-2' style={{ cursor: 'pointer' }}>Perguntas</p>
                <p onClick={() => navigateRoute(URL.tecnico_lista)} className='m-0 sidebar_subtitle  pb-2' style={{ cursor: 'pointer' }}>Doutores</p>
                <p onClick={() => navigateRoute(URL.tipo_atendimento_lista)} className='m-0 sidebar_subtitle  pb-2' style={{ cursor: 'pointer' }}>Tipos de atendimento</p>
                <p onClick={() => navigateRoute(URL.usuarios_lista)} className='m-0 sidebar_subtitle  pb-2' style={{ cursor: 'pointer' }}>Usuários</p>
                <p onClick={() => navigateRoute(URL.menu_settings)} className='m-0 sidebar_subtitle  pb-2' style={{ cursor: 'pointer' }}>Menu</p>
              </Accordion.Body>
            </Accordion.Item>

          </Accordion>
        </div>

        <div className='d-flex justify-content-center flex-column align-items-center gap-2 pb-3 teste' style={{ position: 'absolute', bottom: 0, width: '100%' }}>
          <img src={logo} alt='logo' style={{ width: '50%' }} />
        </div>
      </Nav >


      <div className='page-content'>
        {children}
      </div>

    </div >
  );
};

export default AsideBar;
